<footer class="footer-admin">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-lg-4 col-sm-6 mb-5 mb-lg-0 text-center text-sm-left mr-auto">
        <div class="footer-widget-admin">
          <h4 class="mb-4 admin-text">{{appName}} <small>v{{version}}</small></h4>
          <p class="lead admin-text">{{footerInfo}}</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-2 col-sm-6 mb-5 mb-lg-0 text-center text-sm-left">
        <div class="footer-widget-admin">
          <h4 class="mb-4 admin-text">{{'label.more-info'|transloco}}</h4>
          <ul class="pl-0 list-unstyled mb-0">
            <li><a href="{{ABOUT_US}}" target="_blank">{{'label.about-us'|transloco}}</a></li>
            <li><a [routerLink]="" (click)="toStore()">{{'label.products'|transloco}}</a></li>
            <!--li><a (click)="toSupport()">{{'label.support'|transloco}}</a></li-->
          </ul>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 col-sm-6 text-center text-sm-left">
        <div class="footer-widget">
          <h4 class="mb-4 admin-text"><a href="{{CONTACT_US}}" target="_blank">{{'label.contact'|transloco}}</a></h4>
          <ul class="pl-0 list-unstyled mb-5">
            <li class="admin-text"><i class="tf-ion-ios-location"></i>{{ ' ' + officeLocation }}</li>
            <li class="admin-text"><i class="tf-ion-ios-email"></i>{{ ' ' + contactEmail }}</li>
          </ul>

          <h5 class="admin-text">{{'label.call-now'|transloco}} : {{contactPhone}}</h5>
        </div>
      </div>
    </div>
  </div>
</footer>


<div class="footer-btm-admin py-4 ">
  <div class="container">
    <div class="row {{(isMobile) ? 'text-center':''}}">
      <div class="col-lg-4">
        <p class="copyright mb-0 ">&copy; {{ anio | date: "yyyy" }}{{' '}}<a href="{{providerWeb}}"
            target="_blank">{{orgName}}</a>. Todos los derechos reservados</p>
      </div>
      <div class="col-lg-8 terms-text">
        <ul class="list-inline mb-0 footer-btm-admin-links text-lg-right mt-2 mt-lg-0">
          <li class="list-inline-item"><a (click)="toPP()">{{'label.privacy-policy'|transloco}}</a></li>
          <li class="list-inline-item"><a (click)="toTC()">{{'label.terms-conditions'|transloco}}</a></li>
          <li class="list-inline-item"><a (click)="toCP()">{{'label.cookie-policy'|transloco}}</a></li>
          <li class="list-inline-item" *ngIf="showCookiePreferences"><a (click)="onClickCookiePreferences()">{{'label.cookie-consent-manage'|transloco}}</a></li>
          <li class="list-inline-item"><a (click)="toST()">{{'label.terms-sales'|transloco}}</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
